import { HTTP, request } from "libs/newHttp";

export const getDependantsAPI = () =>
    request({
        method: HTTP.GET,
        url: `consumer/dependant`,
    })